export function blobAsBase64(blobData: Blob): Promise<string> {
  return new Promise<string>((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      if (typeof reader.result !== "string") {
        reject(new Error("File could not be encoded."));
        return;
      }
      resolve(reader.result);
    };
    reader.onerror = () => reject(reader.error ?? new Error("File could not be read."));
    reader.onabort = () => reject(new Error("File reading was aborted."));
    reader.readAsDataURL(blobData);
  });
}
